// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__hypeFont_0eedc9', '__hypeFont_Fallback_0eedc9'"},"className":"__className_0eedc9"};